import { get } from 'lodash';

import { agentMatrixTestTypes } from 'app/util/constants';

/**
 * Tests that would be left with too few agents if this agent were removed.
 * Only private agents are checked; global agents are shared and never blocked here.
 */
export function getAgentRemovalBlockingTests(agentDetails) {
  if (get(agentDetails, 'agent_type') !== 'private') {
    return [];
  }

  return get(agentDetails, 'tests', []).filter((test) => {
    const agents = get(test, 'config.agents', []);
    const minRemainingAgents = agentMatrixTestTypes.includes(test.test_type) ? 2 : 1;
    return !(agents.length > minRemainingAgents);
  });
}

export default getAgentRemovalBlockingTests;
